// extracted by mini-css-extract-plugin
module.exports = {"container":"featuredTournamentsLogo__container___1qJxu","icon":"featuredTournamentsLogo__icon___1X0IW","logo":"featuredTournamentsLogo__logo___2hgrW"};